import React from "react";

import { WizardRouter } from "./views/WizardRouter";

const OnboardingWizardSection: React.FC = () => <WizardRouter />;

export default OnboardingWizardSection;
